<template>
	<div>
		<CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
			<template slot="header">
				<th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh" width="45%">Imagen</th>
				<th :class="StyleTh" width="20%">Nombre</th>
                <th :class="StyleTh">Precio</th>
                <th :class="StyleTh">Tipo de Disponibilidad</th>
                <th :class="StyleTh">Stock</th>
                 
                <th :class="StyleTh+' text-center'">Acciones</th>
			</template>

			<template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index" >
					<td class="text-center"><p :class="StyleTd">{{ (index+1) }}</p></td>
					<td>
                        <img :src="RutaFile+lista.UrlImagen+lista.Nomimagen" width="10%">
                    </td>
                    <td><p :class="StyleTd">{{lista.Nombre}}</p></td>
                    <!-- <td><h6 :class="StylePr">{{$limitCharacters(lista.Descripcion,100)}}</h6></td> -->
                    <td><p :class="StyleTd">$ {{lista.Precio}}</p></td>
                    <td><p :class="StyleTd">{{lista.TipoDisponibilidad}}</p></td>
                    <td><p :class="StyleTd">{{lista.Stock}}</p></td>
                    
					<td class="align-middle text-end">
						<CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="false" :pId="lista.IdArticuloAlmacen" :pEmitSeccion="ConfigList.EmitSeccion" :pGoRoute="ConfigList.GoRoute" :segurity="segurity">
							<template slot="btnaccion">
                                 <!-- Remover v-show en caso de agregar más botones -->
                                 <CMoreButtonsL v-show="segurity.ViewSection">
							        <template slot="bodyBtnsL">
                                        <template v-if="segurity.ViewSection">
                                            <li @click="IraProductos(lista)">
                                                <a class="dropdown-item">
                                                    <i class="fa fa-briefcase"></i> Ver Productos
                                                </a>
                                            </li>
                                        </template>
                                    </template>
                                </CMoreButtonsL>
                            </template>
						</CBtnAccion>     
					</td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="7"></CSinRegistros>
			</template>
		</CList>

		<!-- <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave"></Form>
			</template>
		</CModal> -->
	</div>
</template>

<script>

// import Form from '@/views/catalogos/bancoImagen/Form.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionBancoImagen';

export default {
    name: 'ListaBancoImagen',
    props:['pObjEnviado'],
    components: {
        // Form
    },
    data() {
        return {
            ConfigList:{
                Title: 'Listado',
                IsModal: false,
                ShowLoader: true,
                BtnReturnShow: true,
                EmitSeccion: EmitEjecuta,
                TitleFirst: 'Galería',
                GoRoute:'galeriaImagenForm'
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 10,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            ConfigModal:{
                ModalTitle: "Formulario Galeria",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            ListaHeader: [],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd, 
            ObjArticuloCategoria: {},
            RutaFile: '',
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("articulosAlmacen",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdArticuloCategoria: this.ObjArticuloCategoria.IdArticuloCategoria,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
                this.RutaFile           = res.data.RutaFile;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('articulosAlmacen/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'categoriaGaleria',params:{}});
        },
        IraProductos(item){
            this.$router.push({name:'BancoImagenProductos',params:{pObjBancoImagen: item}});
        }
    },
    created()
    {
        if(this.pObjEnviado != undefined){
            sessionStorage.setItem('objArticuloCategoria',JSON.stringify(this.pObjEnviado));
        }

        this.ObjArticuloCategoria = JSON.parse(sessionStorage.getItem('objArticuloCategoria'));
        this.ConfigList.Title = this.ConfigList.Title+' '+this.ObjArticuloCategoria.Nombre;

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
